export enum WidgetsEnum {
  INSTANT_VALUATION_TOOL = "ivt",
  FORM = "form",
  QUESTIONNAIRE = "questionnaire"
}
